import {
  useCallback,
  useContext, useEffect, useState,
} from 'react';
import { Link } from 'react-router-dom';
import Template from '../../models/Template/Template';
import BlockItem from '../Master/BlocksManagement/BlockItem';
import { PageTemplateCategoriesContext } from '../../contexts/PageTemplateCategoriesContext';
import { PageTemplatesContext } from '../../contexts/PageTemplatesContext';
import ModalComponent from '../../components/ModalComponent';

interface Props {
  title: string
  open: boolean
  handleClose: () => void
  handleTemplateSelected: (template: string) => void
}

const Index = (props:Props) => {
  const {
    title, open, handleClose, handleTemplateSelected,
  } = props;
  const [selectedCategoryId, setSelectedCategoryId] = useState('');
  const [selectedTemplate, setSelectedTemplate] = useState<Template | null>(null);
  const {
    getTemplatesFromCategory,
  } = useContext(PageTemplatesContext);

  const [selectableBlocks, setSelectableBlocks] = useState<Template[]>([]);
  const { pageCategories } = useContext(PageTemplateCategoriesContext);

  const requestForCategories = useCallback((id:string) => {
    const options: {
      page?: number;
    } = {};

    getTemplatesFromCategory(id, options).then((data) => {
      setSelectableBlocks(data.data);
    });
  }, [getTemplatesFromCategory]);

  // デフォルトで一番のカテゴリーを選択します。
  useEffect(() => {
    // すでにカテゴリーメニューを選択された状態なら、なにもしません。
    if (selectedCategoryId !== '') {
      return;
    }

    if (pageCategories.length === 0) {
      return;
    }

    const { id } = pageCategories[0];
    setSelectedCategoryId(id);
    requestForCategories(id);
  }, [pageCategories, selectedCategoryId, open, requestForCategories]);

  useEffect(() => {
    if (open === true) {
      return;
    }
    setSelectedCategoryId('');
    setSelectableBlocks([]);
  }, [open]);

  const handleCategorySelected = useCallback((id:string) => {
    setSelectedCategoryId(id);
    requestForCategories(id);
  }, [requestForCategories]);

  return (
      <>
        <ModalComponent
          size="xl"
          title={title}
          confirmButtonText="ページを作成する"
          onConfirm={() => handleTemplateSelected(selectedTemplate.id)}
          show={open}
          closeModal={handleClose}
          centered
          animation={false}
          disabled={!selectedTemplate}
          bodyClassName="m-0 p-0"
          scrollable
          contentClassName="fullViewportHeight"
        >
          <div className="tab modalTabs">
            <ul className="nav navTabs" role="tablist">
              {pageCategories.map((category) => (
                  <li key={category.id}>
                    <Link
                      className={category.id === selectedCategoryId ? 'active' : ''}
                      onClick={() => handleCategorySelected(category.id)}
                      to="#"
                      data-bs-toggle="tab"
                      role="tab"
                    >
                      {category.title}
                    </Link>
                  </li>
              ))}
            </ul>
            <div className="tab-content tabContent">
              <div id="tabSection_1" className="tab-pane tabPane active">

                <div className="block-list blockselect">
                  {selectableBlocks.map((template) => <BlockItem key={template.id} handleSelect={(template) => setSelectedTemplate(template)} template={template} active={selectedTemplate && (selectedTemplate.id === template.id)} />)}
                </div>
              </div>
            </div>
          </div>
        </ModalComponent>
      </>
  );
};

export default Index;
